import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { DateTime } from 'luxon';
import { Matter } from '../../core/models/matter';
import { PagedList } from '../../core/models/paged-list';
import { MatterService } from '../../core/services/matter.service';


@Component({
  selector: 'app-matters-list',
  templateUrl: './matters-list.component.html',
  styleUrl: './matters-list.component.scss',
})
export class MattersListComponent {
  DateTime = DateTime;

  defaultColumns: string[] = ['name', 'status', 'items', 'link'];

  displayedColumns = this.defaultColumns;

  internalPagedMatters?: PagedList<Matter>;
  loading = true;

  dataSource = new MatTableDataSource(this.internalPagedMatters?.items);

  constructor(private matterService: MatterService) {}

  @Input()
  set pagedMatters(pagedMatters: PagedList<Matter> | undefined) {

    if (pagedMatters == null) {
      return;
    }
    this.internalPagedMatters = pagedMatters;
    this.dataSource.data = pagedMatters.items;

    this.displayedColumns = this.defaultColumns;
  }
}
